import moment from '@/moment-gp'

/* =============================================================================
DB:       Realtime DB
PATH:     goal.{goalId}.meta.lanes.{laneUUID}
          Maybe move to:
          goal.{goalId}.lanes.{laneUUID}
PURPOSE:  Stores lanes of a Kanban board (Trello "lists")
============================================================================= */

export default {
  modelGetters:  {},
  staticGetters: {},
  listGetters:   {},
  staticActions: {},
  schema: {
    create({ sortidx, name, user_id }) {
      return {
        createdAt:      moment.currentTimeServer('REALTIMEDB'),
        name:           name === undefined ? 'Untitled' : name,
        sortidx:        sortidx || 0, // This is the sortix of lanes in the kanban board
        deleted:        false,
        // archived:       false, // TODO: REMOVE!
        active:         true,
        assignedUserId: user_id

        /* This used to be the lane */
        /* Other infos everybody can access about a commitment */
      };
    },
    fields: {
      createdAt: { validate_bolt_type: 'ServerTimestamp' },
      name: {},
      sortidx: { required: true, },
      deleted: {},
      // archived: {},
      active: {},
      assignedUserId: {},
    }
  }
};
